// extracted by mini-css-extract-plugin
export var locationCard = "_gq-0";